module.exports = __webpack_public_path__ + "static/media/vid.a1962cea.mp4";